import { Link } from 'react-router-dom';
import type { VideoItem } from '@/mocks/videos';

interface VideoCardProps {
  video: VideoItem;
  size?: 'normal' | 'large';
}

export default function VideoCard({ video, size = 'normal' }: VideoCardProps) {
  return (
    <Link
      to={`/article/${video.id}`}
      className="group block cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div
        className={`relative overflow-hidden rounded-lg mb-3 ${
          size === 'large' ? 'aspect-[16/7]' : 'aspect-[16/9]'
        }`}
      >
        <img
          src={video.thumbnail}
          alt={video.title}
          title={video.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>

        <span className="absolute bottom-2 right-2 bg-black/75 text-white text-xs px-2 py-0.5 rounded font-medium">
          {video.duration}
        </span>

        {video.isHot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
            热门
          </span>
        )}

        {video.isNew && (
          <span className="absolute top-2 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
            新番
          </span>
        )}

        {video.isHot && video.isNew && (
          <>
            <span className="absolute top-2 left-2 bg-accent-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
              热门
            </span>
            <span className="absolute top-8 left-2 bg-primary-500 text-white text-xs px-2 py-0.5 rounded-full font-medium">
              新番
            </span>
          </>
        )}

        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/10 transition-colors duration-300 flex items-center justify-center">
          <div className="w-12 h-12 rounded-full bg-white/90 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
            <i className="ri-play-fill text-xl text-primary-600"></i>
          </div>
        </div>
      </div>

      <h3 className="text-sm font-medium text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug mb-1.5">
        {video.title}
      </h3>

      <div className="flex items-center gap-3 text-xs text-foreground-500">
        <span className="flex items-center gap-1">
          <i className="ri-star-fill text-accent-500"></i>
          {video.rating}
        </span>
        <span>{video.views}次播放</span>
        <span className="whitespace-nowrap">{video.updateInfo}</span>
      </div>
    </Link>
  );
}